import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { styled, css } from 'styled-components';
import { Button } from '@lyse-as/formds-react';

import { LargeContainer } from 'src/components/container';
import { StyledInformationCard } from 'src/components/information-card/information-card.styled';
import { colorNeutral, colorSecondary200 } from 'src/styles/colors';
import { spacing1, spacing3 } from 'src/styles/spacing';

export interface StyledCartProps {
  $notEmptyCart: boolean;
}

export const StyledTitle = styled(Typography)`
  font-weight: bold;
  margin-bottom: ${spacing1};
`;

export const StyledDesktopCard = styled(StyledInformationCard)`
  background-color: ${colorNeutral};
  display: flex;
  flex-direction: column;
  min-width: 445px;
  position: absolute;
  right: 11px;
  margin-top: 18px;
  padding: ${spacing3};
  border-radius: 2px;
`;

export const StyledArrowUp = styled.div`
  position: absolute;
  top: -16px;
  right: 29px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 16px solid ${colorSecondary200};

  &::before {
    content: '';
    position: relative;
    top: -17px;
    right: 7px;
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 14px solid ${colorNeutral};
  }
`;

export const stylesNotEmptyCart = css`
  top: 16px;
`;

export const StyledContainer = styled(LargeContainer)<StyledCartProps>`
  display: flex;
  justify-content: flex-end;
  margin-top: -68px;
  margin-bottom: 68px;
  height: 0;
  position: sticky;
  ${({ $notEmptyCart }) => $notEmptyCart && stylesNotEmptyCart};
`;

export const StyledButtonContainer = styled.div`
  margin-top: ${spacing1};
  display: flex;
  justify-content: center;
`;

export const StyledButton = styled(Button)`
  margin-top: 2px;
`;
